export const CREATE_REPORTED_ISSUE_REQUEST = 'CREATE_REPORTED_ISSUE_REQUEST';
export const CREATE_REPORTED_ISSUE_SUCCESS = 'CREATE_REPORTED_ISSUE_SUCCESS';
export const CREATE_REPORTED_ISSUE_FAILURE = 'CREATE_REPORTED_ISSUE_FAILURE';
export const CREATE_REPORTED_ISSUE_RESET = 'CREATE_REPORTED_ISSUE_RESET';